var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Cross.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const Cross = ({
  color = '#7f7f9e',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("g", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.2304 4.00001L4 10.2304M10.2304 10.2304L4 4",
      stroke: color,
      strokeWidth: "1.5"
    })
  })
});